import { render, staticRenderFns } from "./Blogroll.vue?vue&type=template&id=3689ecc1&"
import script from "./Blogroll.vue?vue&type=script&lang=js&"
export * from "./Blogroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports